/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';
// utils
import { url } from 'utils/urls';
// material
import { TextField } from '@insticator/insticator-ui'
import { ReactComponent as ComposeIcon } from 'assets/icons/compose.svg'
import { ReactComponent as NoneIcon } from 'assets/icons/none.svg'
import Space from 'material/space/space';
import { ConfigToggle, SectionGroupV2 } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './headertitle_styles'
import PreviewConfig from 'material/previewconfig/previewconfig'
import { setTrendingNowConfigSectionValid } from 'state/slices/trendingnowv2';
import { useDispatch } from 'react-redux';

const icons = {
  UP_TREND: <img src={`${url.image}/2.0/trendingnow/general/header-uptrend.png`} alt={''} />,
  THUNDER: <img src={`${url.image}/2.0/trendingnow/general/header-thunder.png`} alt={''} />,
  BLACK_FIRE: <img src={`${url.image}/2.0/trendingnow/general/header-black-fire.png`} alt={''} />,
  FIRE: <img src={`${url.image}/2.0/trendingnow/general/header-fire.svg`} alt={''} />,
  NONE: ''
}

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: GENERAL SECTION : HEADER TITLE ~~~~~~~~~~ ========== */
const HeaderTitle = injectSheet(styles)((props) => {

  const dispatch = useDispatch()

  const { enableHeader, enableHeaderBorder, headerIcon, headerTitle, onChange } = props

  const handleIconChange = icon =>  onChange({'headerIcon': icon})

  useEffect(() => {
    if(headerTitle) dispatch(setTrendingNowConfigSectionValid({configName: 'generalConfig', isValid: true}))
    else dispatch(setTrendingNowConfigSectionValid({configName: 'generalConfig', isValid: false}))
  }, [dispatch, headerTitle])

  return (
    <SectionGroupV2 
      indented={true} 
      klass={`headertitle ${props.classes.headertitle}`} 
      title={'Header title'} 
      description={'Customize the title with your own phrase and imagery.'}
      rowGap={32} 
      direction={'column'}>
        <Space gap={48}>
          <ConfigToggle
            title={'Enable header'}
            description={'Customize the title with your own phrase and imagery.'}
            checked={enableHeader}
            indented={false}
            onChange={val => onChange({'enableHeader': !enableHeader})}
          >
          <Space direction={'column'} gap={16}>
            <TextField 
              type={`text`} 
              name={`headerTitle`} 
              icon={<ComposeIcon />}
              value={headerTitle} 
              handleChange={e => onChange({'headerTitle': e.target.value})}
              placeholder={``} 
              required
              valid={!!headerTitle}
              maxLength={128}
            />
            <p>Choose an icon style </p>
            <Space klass={'headericons'}>
              <div className={`icon selected-${headerIcon === 'UP_TREND'}`} onClick={() => handleIconChange('UP_TREND')}>
                {icons['UP_TREND']}
              </div>
              <div className={`icon selected-${headerIcon === 'THUNDER'}`} onClick={() => handleIconChange('THUNDER')}>
                {icons['THUNDER']}
              </div>
              <div className={`icon selected-${headerIcon === 'BLACK_FIRE'}`} onClick={() => handleIconChange('BLACK_FIRE')}>
                {icons['BLACK_FIRE']}
              </div>
              <div className={`icon selected-${headerIcon === 'FIRE'}`} onClick={() => handleIconChange('FIRE')}>
                {icons['FIRE']}
              </div>
              <div className={`icon none selected-${headerIcon === 'NONE'}`} onClick={() => handleIconChange('NONE')}>
                <NoneIcon />
              </div>
            </Space>
            <ConfigToggle 
              title={'Enable header border'}
              checked={enableHeaderBorder}
              onChange={val => onChange({'enableHeaderBorder': !enableHeaderBorder})}
              gap={16}
            />
          </Space>
          </ConfigToggle>
          <PreviewConfig>
            <Space>
              {icons[headerIcon]}
              <h3>{headerTitle}</h3>
            </Space>
          </PreviewConfig>
        </Space>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default HeaderTitle;